import React, { lazy, Suspense } from "react";
import EstateProperty from "@/pages/sites/EstateProperty";
import { isEstate, isPreviewing } from "@/lib/sitePreview";
import { useBrand } from "@/lib/brand";
import { SITE_FALLBACK } from "@/lib/classicChunk";

// The classic design, fetched only if this agency is on it. See
// pages/classic/PublicListingDetailClassic.jsx for why it is not imported directly.
const PublicListingDetailClassic = lazy(() => import("@/pages/classic/PublicListingDetailClassic"));

function ClassicProperty() {
  return <Suspense fallback={SITE_FALLBACK}><PublicListingDetailClassic /></Suspense>;
}

/** Public property detail page for the shop-window marketplace. */
export default function PublicListingDetail() {
  const brand = useBrand();
  const estate = isEstate(brand);
  const previewing = isPreviewing(brand);
  if (estate) return <EstateProperty preview={previewing} />;
  return <ClassicProperty />;
}
